import React, { useEffect } from 'react';
import './style.scss';
import { IconColor, IconSize, SvgIcon } from 'views/components/atoms/svgIcon';
import { IconName, findIcon } from 'views/utils/handleIcon';

export enum ToastMessageLevel {
  Info = 0,
  Warn = 1,
  Error = 2,
}

const toastMessageLevelToColor = (level: ToastMessageLevel): IconColor => {
  switch (level) {
    case ToastMessageLevel.Info:
      return IconColor.primary;
    case ToastMessageLevel.Warn:
      return IconColor.warn;
    case ToastMessageLevel.Error:
      return IconColor.danger;
    default:
      return IconColor.primary;
  }
};

export type ToastProps = {
  label?: string;
  isActive: boolean;
  messageLevel: ToastMessageLevel;
  setIsActive: React.Dispatch<React.SetStateAction<boolean>>;
};

const icon = findIcon(IconName.Caution);
const cancelIcon = findIcon(IconName.Cancel);

export const Toast = (props: ToastProps) => {
  const { label, isActive, messageLevel, setIsActive } = props;
  const iconColor = toastMessageLevelToColor(messageLevel);

  // 画像がオフラインになっている場合では読み込めないため事前に読み込むためにdisplayで制御
  // エラー表示に用いるものなのでオフラインでも画像が表示されている必要がある
  const displayStyle = isActive ? {} : { display: 'none' };

  return (
    <div className="toast" style={displayStyle}>
      <div className="toast_icon">
        <SvgIcon icon={icon} size={IconSize.icon_m} color={iconColor} />
      </div>
      <div className="toast_label">
        <span>{label}</span>
      </div>
      <div className="toast_cancel" onClick={() => setIsActive(false)}>
        <SvgIcon icon={cancelIcon} size={IconSize.icon_m} />
      </div>
    </div>
  );
};
